<template>
    <div>
        <div class="footerBG">
            <div class="footerCont">
                <div class="footerContL">
                    <img class="footerContLImg" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/mainlogo.png" alt="">
                    <div class="footerContLline"></div>
                    <div class="footerContLC">
                        <div class="footerContLCT1"><span @click="gohome" class="dx">首页</span>   丨   <span @click="goretail" class="dx">零售行业</span>   丨   <span @click="goeducation" class="dx">教育行业</span>   丨   <span @click="gocooperation" class="dx">合作案例</span>   丨   <span @click="gowe" class="dx">关于我们</span></div>
                        <div class="footerContLCT2">
                            <img class="footerContImg" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/location.png" alt="">
                            <div>地址：中国(上海)自由贸易试验区张江路665号3层</div>
                        </div>
                        <div class="footerContLCT2">
                            <img style="width: 11px;" class="footerContImg" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/Email.png" alt="">
                            <div>邮箱：marketing@unishining.com</div>
                        </div>
                    </div>
                </div>
                <div class="footerContR">
                    <img style="width: 92px;position:relative;" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/zxqr4.jpg" alt="">
                </div>
            </div>
        </div>
        <div class="footer">
            Copyright 2017-2024 炯耀信息技术（上海）有限责任公司版权所有 <a style="color:rgba(67,67,67,1);margin-left: 5px;margin-right: 5px;" href="https://beian.miit.gov.cn">沪ICP备18005702号-1</a> 点击备案号即可跳转链接：<a style="color:rgba(67,67,67,1);" href="https://beian.miit.gov.cn">https://beian.miit.gov.cn</a>。
        </div>
    </div>
</template>

<script>
    export default {
        name: "Footer",
        methods:{
            gohome(){
                this.$router.push('/')
            },
            gowe(){
                this.$router.push('/we')
            },
            gocooperation(){
                this.$router.push('/cooperation')
            },
            goretail(){
                this.$router.push('/retail')
            },
            goeducation(){
                this.$router.push('/education')
            },
        }
    }
</script>

<style lang="less" scoped>
.footerBG{
    width: 100%;
    height: 150px;
    background: #212121;
    .footerCont{
        width: 1200px;
        height: 100%;
        margin: 0 auto;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .footerContL{
            display: flex;
            .footerContLImg{
                height: 45px;
                position: relative;
                top: 16px;
            }
            .footerContLline{
                width:1px;
                height:75px;
                background:rgba(255,255,255,.1);
                margin: 0 40px;
            }
            .footerContLC{
                width: 500px;
                .footerContLCT1{
                    font-size:14px;
                    font-weight:500;
                    color: #fff;
                    margin-bottom: 26px;
                    display: flex;
                }
                .footerContLCT1 .dx:hover{
                    text-decoration: underline;
                    cursor: pointer;
                }
                .footerContLCT2{
                    display: flex;
                    align-items: center;
                    font-size:14px;
                    color:rgba(154,154,154,1);
                    .footerContImg{
                        margin-right: 10px;
                    }
                }
            }
        }
    }
}
.footer{
    width: 100%;
    height:30px;
    background:rgba(16,16,16,1);
    display: flex;
    justify-content: center;
    align-items: center;
    font-size:12px;
    font-weight:500;
    color:rgba(67,67,67,1);
}
</style>